import { EntityPage, ValidityBadge } from "@/components/EntityPage";

export default function Vehicles() {
  const fields = [
    { key: "vehicle_type", label: "Type", required: true },
    { key: "vehicle_name", label: "Name", required: true },
    { key: "registration_no", label: "Registration No", required: true },
    { key: "tax_validity", label: "Tax valid till", type: "date" },
    { key: "insurance_validity", label: "Insurance valid till", type: "date" },
    { key: "fitness_validity", label: "Fitness valid till", type: "date" },
    { key: "permit_validity", label: "Permit valid till", type: "date" },
    { key: "pollution_validity", label: "Pollution valid till", type: "date" },
  ];
  const columns = [
    { key: "vehicle_type", label: "Type" },
    { key: "vehicle_name", label: "Name" },
    { key: "registration_no", label: "Registration", mono: true },
    { key: "tax_validity", label: "Tax", render: (r) => <ValidityBadge date={r.tax_validity} /> },
    { key: "insurance_validity", label: "Insurance", render: (r) => <ValidityBadge date={r.insurance_validity} /> },
    { key: "fitness_validity", label: "Fitness", render: (r) => <ValidityBadge date={r.fitness_validity} /> },
    { key: "permit_validity", label: "Permit", render: (r) => <ValidityBadge date={r.permit_validity} /> },
    { key: "pollution_validity", label: "Pollution", render: (r) => <ValidityBadge date={r.pollution_validity} /> },
  ];
  return (
    <EntityPage
      title="Vehicles" subtitle="Fleet inventory with document validity tracking. Amber = expiring within a week."
      endpoint="vehicles" fields={fields} columns={columns}
      exportFilename="vehicles"
    />
  );
}
